import { PageResponse } from '@models/page-response';
import { MainComponent } from '../main/main.component';
import { TranslateService } from '@ngx-translate/core';
import { AppConstant } from '@constants/app.constant';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { Component } from '@angular/core';
import { switchMap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Group, GroupSearchingCriteria } from '@app/models/group';
import { GroupService } from '@app/services/group.service';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { BaseSearchingCriteria } from '@app/models/customer/company';
import { OrderService } from '@app/services/order.service';
import { Order, OrderSearchingCriteria } from '@app/models/order';
import { DateUtils } from '@app/utils/date-utils';

@Component({
    selector: 'order-list',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent {

    private searchTermStream = new Subject<string>();

    loading: boolean = false;

    globalCriteria: string = '';
    searchingCriteria: OrderSearchingCriteria = new OrderSearchingCriteria();

    page: number = 1;
    size: number = 10;
    totalItems: number = 0;
    sortField: string;
    sortDirection: 'asc' | 'desc';

    pagingInfo: {
        start: number;
        end: number;
        total: number;
    }

    records: Order[];

    constructor(private router: Router,
        private route: ActivatedRoute,
        public appConstant: AppConstant,
        private emailTemplateService: OrderService,
        private translate: TranslateService,
        private mainComponent: MainComponent) {
    }

    ngOnInit(): void {

        this.loading = true;
        this.pagingInfo = {
            start: 0,
            end: 0,
            total: 0
        }

        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.globalCriteria = params['global'] || '';
                    this.page = Number(params['page']) || 1;
                    this.sortField = params['sortField'] || 'code';
                    this.sortDirection = params['sortDirection'] || 'asc';

                    if (params['searchingCriteria'] != null) {
                        this.searchingCriteria = JSON.parse(params['searchingCriteria']);
                    } else {
                        this.searchingCriteria = new OrderSearchingCriteria();
                    }

                    return this.emailTemplateService.globalSearch(this.globalCriteria, this.searchingCriteria, this.page - 1, this.size, this.sortField, this.sortDirection);
                })
            )
            .subscribe((res: PageResponse<Order>) => {
                this.loading = false;
                this.page = res.number + 1;
                this.totalItems = res.totalElements;
                this.records = res.content;
                this.pagingInfo.start = (this.page - 1) * this.size + 1;
                this.pagingInfo.end = this.page * this.size;
                this.pagingInfo.total = this.totalItems;
                if (this.pagingInfo.end > this.pagingInfo.total) {
                    this.pagingInfo.end = this.pagingInfo.total;
                }
            });

        this.searchTermStream
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((term: string) => this.doSearch(this.globalCriteria, this.page, this.sortField, this.sortDirection));

    }

    sort(field: string): void {
        this.sortField = field;

        if (this.sortField === field) {
            this.sortDirection === 'asc' ? this.sortDirection = 'desc' : this.sortDirection = 'asc';
        } else {
            this.sortField = field;
            this.sortDirection === 'asc';
        }

        this.doSearch(this.globalCriteria, this.page, field, this.sortDirection);
    }

    ngOnDestroy(): void {
    }

    pageChange(changedPage: number): void {
        if (this.page != changedPage) {
            this.doSearch(this.globalCriteria, changedPage, this.sortField, this.sortDirection);
        }
    };

    search(term: string) {
        this.page = 0;
        this.searchTermStream.next(term);
    }

    private doSearch(criteria: string, page: number, sortField: string, sortDirection: string) {
        this.records = [];
        this.loading = true;
        this.router.navigate([ModulePathConstant.ORDER_PATH, {
            global: criteria,
            page: page,
            sortField: sortField,
            sortDirection: sortDirection,
            searchingCriteria: JSON.stringify(this.searchingCriteria)
        }]);
    }

    getOrderDate(record: any){

        // var dateresult = record.orderDate;
        var hisTimeZoneStr = record.utcTimeZone;
        if(hisTimeZoneStr && hisTimeZoneStr.startsWith('UTC+')){
            hisTimeZoneStr=hisTimeZoneStr.substring(4);
        }
        // var hisTimeZoneNum = hisTimeZoneStr?parseInt(hisTimeZoneStr):8;

        // try{
        //     if(dateresult.indexof(" ")>0){
        //         return this.convertTimeFromToLocal(dateresult, hisTimeZoneNum);
        //     }
        //     return new Date(parseFloat(dateresult)).toLocaleDateString();
        // }catch(e){
        //     console.log(' exception: '+dateresult);
        // }
        return record.orderDate;// +"   (UTC"+hisTimeZoneStr+")";
    }

    getUtcTimeZoneNum(){
        return (0 - new Date().getTimezoneOffset() / 60);
    }

	convertTimeFromToLocal(datetimestr, timezonenum){
        console.log('>>>'+datetimestr);
        var dtpart = datetimestr.split(" ");
        var datep = dtpart[0].split('-');
        var timep= dtpart[1].split('\:');
        var d8 = new Date(parseInt(datep[0]),parseInt(datep[1])-1,
                          parseInt(datep[2]),parseInt(timep[0]),
                          parseInt(timep[1]),parseInt(timep[2]));
       var utctm = d8.getTime()+(-1)*(timezonenum)*3600000;
       var ucc = new Date(utctm+3600000*this.getUtcTimeZoneNum());
       return ucc;
   }
    
		//  getOrderDate(){
			
		// 	var time1 = new Date().format("yyyy-MM-dd hh:mm:ss");
		// 	return time1;
		// }
		
		 getUtcTimeZone(){
			let res = (0 - new Date().getTimezoneOffset() / 60);
            if(res<0){
                return "UTC-"+res;
            }
            return "UTC+"+res;
        }
}
